import React from 'react';
import { Box, Tabs, TabsProps, Tooltip, useTheme } from '@mui/material';
import ExportExcel from './ExportExcel';

export interface TabExportData {
    data: any[];
    columns: Array<{ key: string; header: string }>;
    label: string;
    exportType?: string;
}

export interface TabsWithExportProps extends TabsProps {
    exportData?: TabExportData | null;
}

const TabsWithExport: React.FC<React.PropsWithChildren<TabsWithExportProps>> = ({
    exportData,
    children,
    ...tabsProps
}) => {
    const theme = useTheme();
    // Use a fill color that is readable in both light and dark modes
    const exportFill = theme.palette.mode === 'dark'
        ? theme.palette.success.light
        : theme.palette.success.dark;

    return (
        <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
            <Tabs {...tabsProps} sx={{ ...(typeof tabsProps.sx === 'object' ? tabsProps.sx as object : {}), ...(exportData ? { pr: '44px' } : {}) }}>
                {children}
            </Tabs>
            {exportData && (
                <Tooltip title={`Export "${exportData.label}" to Excel`} placement="left">
                    <Box sx={{ position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)', zIndex: 1 }}>
                        <ExportExcel
                   
                            label={exportData.label}
                            results={exportData.data}
                            total={exportData.data.length}
                            exportType={exportData.exportType ?? 'details'}
                            columns={exportData.columns}
                            size="small"
                            sx={{width:'36px', height:'36px', fill: exportFill }}
                        />
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
};

export default TabsWithExport;
